import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { searchCategory } from "../../lib/api/search";
import { mapProduct } from "../../state/modules/search/product/mapAndInsertProducts/mapProduct";
import {
  getSearchApiDefaults,
  getStoreUrl
} from "../../state/modules/config/selectors";

import logger from "../../lib/logger";

export const useSearchCategory = ({ cid, params }) => {
  const [products, setProducts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const apiDefaults = useSelector(getSearchApiDefaults);
  const storeUrl = useSelector(getStoreUrl);

  const apiQueryObject = {
    ...apiDefaults,
    ...params,
    cid,
    offset: 0
  };
  const fetchData = () => {
    searchCategory(apiQueryObject)
      .then(res => {
        const newProducts = res.products.map(product => {
          const url = `${storeUrl}/${product.url}`;

          return {
            ...mapProduct({ product }),
            url,
            tileId: product.id
          };
        });

        setProducts(newProducts);
      })
      .catch(error => {
        setIsError(true);
        error.message = `useSearchCategory failed, and caught error: ${error.message}`;
        logger.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [cid]);

  return {
    products,
    isLoading,
    isError
  };
};
